import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { motion } from "framer-motion";
import { Shield, Filter } from "lucide-react";

export default function AdminAuditPage() {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const { api } = useAuth();

    useEffect(() => {
        api.get("/v2/admin/audit?limit=100").then(r => setLogs(r.data.logs)).catch(console.error).finally(() => setLoading(false));
    }, []);

    const EVENT_COLORS = {
        workspace_created: "text-blue-400 bg-blue-500/10",
        user_created: "text-green-400 bg-green-500/10",
        user_updated: "text-gray-300 bg-gray-500/10",
        impersonation_started: "text-yellow-400 bg-yellow-500/10",
        impersonation_ended: "text-yellow-300 bg-yellow-500/10",
    };

    return (
        <div className="p-8" data-testid="admin-audit">
            <div className="mb-8">
                <h1 className="text-2xl font-display font-bold text-white">Audit Log</h1>
                <p className="text-sm text-gray-500 mt-1">Permanent record of all consequential platform events</p>
            </div>

            <div className="bg-card border border-border/40">
                <div className="grid grid-cols-[1.5fr_2fr_3fr_1.5fr] px-5 py-3 border-b border-border/40 text-xs text-gray-600 font-body">
                    <span>Event</span><span>User</span><span>Details</span><span>Time</span>
                </div>
                {logs.map((l, i) => (
                    <motion.div key={l.id} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: i * 0.015 }}
                        className="grid grid-cols-[1.5fr_2fr_3fr_1.5fr] px-5 py-3 border-b border-border/20 items-center">
                        <span><span className={`text-xs px-2 py-0.5 ${EVENT_COLORS[l.event_type] || "text-gray-400 bg-gray-500/10"}`}>{l.event_type?.replace(/_/g, " ")}</span></span>
                        <span className="text-xs text-gray-400 font-mono">{l.user_id?.slice(0, 8) || "system"}</span>
                        <span className="text-xs text-gray-500 truncate">{JSON.stringify(l.details || {}).slice(0, 80)}</span>
                        <span className="text-xs text-gray-600 font-mono">{l.timestamp?.slice(0, 19).replace("T", " ")}</span>
                    </motion.div>
                ))}
                {logs.length === 0 && !loading && (
                    <div className="p-8 text-center text-sm text-gray-600">No audit events yet</div>
                )}
            </div>
        </div>
    );
}
